import React from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { makeCsv, getTableDataForExport , getColKeyArrayObject} from 'state/actions/users';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import {Col} from 'react-bootstrap'; 
import {   useFormatDate } from 'hooks';
import { API_URL } from 'constants';
 
const ContratsList = () => {

  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [colexport, setColExport] = React.useState([]);


  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('contracts').doc(id).update({delete:true}).then((snap)=> {
        toast.success("Le contrat à été supprimé");
        loadContracts()
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    } 
  };

  const del = (id) => {
    if(confirm(`Êtes vous certain de vouloir supprimer le contrat ?`)){
      delIt(id);
    }
  }

  const columns = [
    {
      accessor: 'origin_id',
      Header: 'Numéro de demande interne',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'property',
      Header: 'Villa',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { property } = rowData.row.original
        return(<>{property &&  property?.label !== undefined && (
            <small className="has-text-grey is-abbr-like">
               {property?.label}
             </small> 
         )}
         </>)
      }
    },
    {
      accessor: 'Date',
      Header: 'Date checkin - checkout',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const {   checkin, checkout } = rowData.row.original
        return(<>{ checkin?.toDate !== undefined &&  checkout?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
               {useFormatDate( checkin?.toDate(), {
                   day:'numeric',
                 weekday: 'short',
                 year: 'numeric',
                 month: 'short', 
               })} au {useFormatDate( checkout?.toDate(), {
                day:'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short', 
            })}
             </small> 
         )}
         </>)
      }
    },
    {
      accessor: 'clientName',
      Header: 'Nom Prénom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'sign',
      Header: 'Signé (client)',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { signdate, checkin } = rowData.row.original
        return(<>{signdate  !== undefined && (
            <small className="has-text-grey is-abbr-like">
               {useFormatDate(signdate, {
                   day:'numeric',
                 weekday: 'short',
                 year: 'numeric',
                 month: 'short', 
               })}
             </small> 
         )}
         </>)
      }
    },
    {
      accessor: 'signbohouse',
      Header: 'Signé (bo-house)',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { sign } = rowData.row.original
        console.log("sign", rowData.row.original)
        return(<>{sign?.bohouse && sign?.bohouse_date  && (
            <small className="has-text-grey is-abbr-like">
           
               {useFormatDate(sign?.bohouse_date.toDate() , {
                   day:'numeric',
                 weekday: 'short',
                 year: 'numeric',
                 month: 'short', 
               })}
             </small> 
         )}
         </>)
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { id, sign, signdate } = rowData.row.original
        return(<>
        {sign?.bohouse === null || sign?.bohouse === undefined && (
          <>
          <IconButton  href={`/contract/${id}`}
          variant="falcon-default"
          size="sm"
          icon="sign"
          transform="shrink-3"
          className='me-2'
        >
          signé
        </IconButton>
          </>
        )}
        <IconButton  href={`/contract/${id}`}
          variant="falcon-default"
          size="sm"
          icon="eye"
          transform="shrink-3"
          className='me-2'
        >
          <span className="d-none d-sm-inline-block ms-1"></span>
        </IconButton> 
        
        {!(signdate != undefined) && (<IconButton  href={`#`} onClick={() => del(id)}
          variant="falcon-danger"
          size="sm"
          icon="trash"
          transform="shrink-3"
          className='me-2'
        >
          <span className="d-none d-sm-inline-block ms-1"></span>
        </IconButton> )}
        
        </>
        )
      }
    }
  ];

  const loadContracts = () => {

    firebase.firestore().collection('contracts')
    .orderBy("_update_At", "desc")
    .get().then((snap)=> {
        let s = [];
        snap.forEach((d) => {
          var l = d.data();
          l.id = d.id;
          l.clientName = l.client.label
          l.signdate = l.sign?.date ? l.sign?.date.toDate() : undefined
          if (l.delete){

          }else{
            s.push(l) 
          }
        })
        setData(s);
        // console.log("contracts", s)
        setColExport(getColKeyArrayObject(s));
      }).catch((error) => {
        setL(false); 
        var errorMessage = error.message;
        toast.error(errorMessage);
      })
  }


  React.useEffect(() => {
    if (data.length === 0){
        loadContracts()
    }
  }, []);

// const data = [
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"modérateur"
//   },
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"admin"
//   },
// ];
 
 
 

function AdvanceTableExample() {

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={205}
    > 
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
      <div id="orders-actions">
        {/* <a href='#' onClick={() => { 
                fetch(`${API_URL}sendInfoFileBooking`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ }),
                }).then((res) => res.json())
                    .then((data) => {
                        console.log("data", data); 
                    }); 
        }}>test</a>  */}
                                
      <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table/>
        </Col>
    </div>
      </Col>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
} 


    return (
      
      <FalconComponentCard>
      <FalconComponentCard.Header
        title="Contrats"
        light={false}
        className="border-bottom border-200" noPreview={true} 
      />
      <FalconComponentCard.Body>
        <AdvanceTableExample />
      </FalconComponentCard.Body>
    </FalconComponentCard>
    );
}

export default ContratsList;
